<template>
  <div>
    <section-why-vivense ref="whyVivense"></section-why-vivense>
    <section-how-it-works ref="howItWorks"></section-how-it-works>
    <section-what-can-i-sell ref="whatCanISell"></section-what-can-i-sell>
    <section-faq ref="faq"></section-faq>
  </div>
</template>

<script>
import SectionWhyVivense from './WhyVivense';
import SectionHowItWorks from './HowItWorks';
import SectionWhatCanISell from './WhatCanISell';
import SectionFaq from './Faq';

export default {
  name: 'HomeSections',
  components: {
    SectionWhyVivense,
    SectionHowItWorks,
    SectionWhatCanISell,
    SectionFaq,
  },
  props: {
    activeSection: {
      type: String,
      default: null,
    },
  },
  methods: {
    handleScroll() {
      this.$nextTick(() => {
        const scroll = window.scrollY;

        const offsetTopWhyVivense = this.$refs['whyVivense'].$el.offsetTop;
        const offsetTopHowitWork = this.$refs['howItWorks'].$el.offsetTop;
        const offsetTopWhatICanSell = this.$refs['whatCanISell'].$el.offsetTop;
        const offsetTopFaq = this.$refs['faq'].$el.offsetTop;

        if (
          scroll >= offsetTopWhyVivense - 5 &&
          scroll < offsetTopHowitWork - 5
        ) {
          this.$emit('update:activeSection', 'whyVivense');
        } else if (
          scroll >= offsetTopHowitWork - 5 &&
          scroll <= offsetTopWhatICanSell - 5
        ) {
          this.$emit('update:activeSection', 'howItWork');
        } else if (
          scroll >= offsetTopWhatICanSell - 5 &&
          scroll <= offsetTopFaq - 5
        ) {
          this.$emit('update:activeSection', 'whatCanISell');
        } else if (scroll >= offsetTopFaq - 5) {
          this.$emit('update:activeSection', 'faq');
        } else {
          this.$emit('update:activeSection', null);
        }
      });
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>
